import styled from 'styled-components';

export const InputWrapper = styled.div<{ hasError: boolean }>`
  position: relative;
  width: calc(100% - 4px);
  height: 40px;
  margin: 0 auto 0px auto;
  background-color: #000000;
  border: 1px solid ${(props) => (props.hasError ? '#dd3086' : '#7d8386')};
  border-radius: 4px;
`;

export const InputElement = styled.input`
  width: 100%;
  height: 100%;
  padding: 5px 10px;
  background: none;
  border: none;
  color: #edf8fc;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  &::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
    transition: opacity 0.1s;
  }

  &:-ms-input-placeholder {
    color: rgba(255, 255, 255, 0.6);
  }

  &:-webkit-autofill {
    -webkit-text-fill-color: #edf8fc;
    box-shadow: 0 0 0px 1000px #000000 inset;
    border-radius: 4px;
  }

  &:focus {
    &::placeholder {
      opacity: 0;
    }
  }
`;
